import React, { FC, useEffect, useRef, useState } from 'react'
import { FileItem } from 'picker'
import { toast as defaultToast } from 'material-react-toastify'
import { Collapse, Drawer } from '@mui/material'
import { VscClose } from 'react-icons/vsc'
import { AiOutlineLoading } from 'react-icons/ai'
import { useConfirm } from 'material-ui-confirm'
import { MdOutlineKeyboardArrowDown } from 'react-icons/md'
import Image from '../../Image'
import ImagePicker from '../../picker/image-picker'
import { getEmail } from '../../../api/service/user'
import { RadioButton } from './RadioButton'
import { Rating } from './Rating'
import { scrollToReviews } from './utils'
// import { scrollToReviews, saveReview } from './utils'
import { BASE_URL, FITTING_ARR, STRETCH_ARR } from './config'
import { useWindowSize } from '../../../hooks/useWindowSize'
import { styleBtnBlack, styleBtnWhite } from '../../../theme/button'
import { useRecaptchaHook } from '../../../hooks/useRecaptchaHook'

let submitTimer: NodeJS.Timeout | null = null

const outerToast = (msg: string) => {
  window.parent.postMessage({ toast: msg }, '*')
}

const getName = () =>
  typeof window !== 'undefined'
    ? window.localStorage.getItem('_nick_name') || ''
    : ''

const getReviewEmail = () =>
  typeof window !== 'undefined'
    ? window.localStorage.getItem('_review_email') || ''
    : ''
// const getReviewFigure = () => {
//   typeof window !== 'undefined'
//   ? window.localStorage.getItem('_review_figure') || ''
//   : ''
// }
// eslint-disable-next-line import/prefer-default-export
export const FormDrawer: FC<{
  drawerOpen: boolean
  onClose: any
  figure: any
  productId: string | number
  pTitle: string | number
  pCover: string
  pHandle: string
  reviewReportData: any
  platform: string
  isEmail?: boolean
  isExtension?: boolean
  loginEmail?: string
}> = ({
  drawerOpen,
  onClose,
  figure,
  productId,
  pTitle,
  pCover,
  pHandle,
  reviewReportData,
  platform,
  isEmail,
  isExtension = false,
  loginEmail,
}) => {
  const { executeReCaptcha } = useRecaptchaHook(
    process.env.NEXT_PUBLIC_SITE_KEY || ''
  )
  // const token = useRecaptchaHook(process.env.NEXT_PUBLIC_SITE_KEY || '')
  const toast = isExtension ? { dark: outerToast } : defaultToast
  const confirm = useConfirm()
  const getInputEmail = () => {
    if (loginEmail) {
      return loginEmail
    }
    return getEmail() || getReviewEmail() || ''
  }
  const initForm = {
    averageRating: 0,
    costEffective: 0,
    comfort: 0,
    stretch: -1,
    fitting: -1,
    body: '',
    height: -1,
    weight: -1,
    bust: -1,
    waist: -1,
    hips: -1,
    name: getName() || '',
    email: getInputEmail(),
  }
  const averageRatingRef = useRef<any>()
  const costEffectiveRef = useRef<any>()
  const comfortRef = useRef<any>()
  const stretchRef = useRef<any>()
  const fittingRef = useRef<any>()
  const bodyRef = useRef<any>()
  const nameRef = useRef<any>()
  const emailRef = useRef<any>()
  const [step, setStep] = useState(0)
  const [openMoreRating, setOpenMoreRating] = useState(false)
  const [form, setForm] = useState(initForm)
  const [needConfirm, setNeedConfirm] = useState(false)
  const [showError, setShowError] = useState<{
    averageRating: boolean
    costEffective: boolean
    comfort: boolean
    stretch: boolean
    fitting: boolean
    body: boolean
    height: boolean
    weight: boolean
    bust: boolean
    waist: boolean
    hips: boolean
    name: boolean
    email: boolean
  }>({
    averageRating: false,
    costEffective: false,
    comfort: false,
    stretch: false,
    fitting: false,
    body: false,
    height: false,
    weight: false,
    bust: false,
    waist: false,
    hips: false,
    name: false,
    email: false,
  })
  const [loading, setLoading] = useState<boolean>(false)
  const [bodyWords, setBodyWords] = useState(0)
  const [value, setValue] = useState<FileItem[]>([])
  const { upSm } = useWindowSize()

  function getUserFigure(email: string) {
    fetch(`${BASE_URL}/review/find_figure?email=${email}`)
      .then((res) => res.json())
      .then((data) => {
        console.log(data.body)
        if (data?.body?.value) {
          setTimeout(() => console.log(data.body, form), 0)
          const fig = data?.body?.value
          setForm({
            ...form,
            height: fig.heights,
            weight: fig.weights,
            bust: fig.busts,
            waist: fig.waists,
            hips: fig.hips,
          })
        }
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.log(err)
        toast.dark('Failed to fetch figure data')
      })
  }
  const getUserFigureLocal = () => {
    if (typeof window !== 'undefined') {
      const localFigure = window.localStorage.getItem('_review_figure')
      if (localFigure) {
        setForm({ ...form, ...JSON.parse(localFigure) })
      }
    }
  }

  const onChange = (arr: FileItem[]) => {
    setValue(arr)
  }

  // eslint-disable-next-line consistent-return
  async function upload(base64: string) {
    try {
      const res = await fetch(`${BASE_URL}/uploadImg`, {
        method: 'POST',
        mode: 'cors',
        headers: {
          'content-type': 'application/json',
        },
        body: JSON.stringify({
          files: base64,
        }),
      })
      if (res.status === 200 && res.ok) {
        const data = await res.json()
        return data.body.url
      }
      return null
    } catch (e: any) {
      console.log(e)
      toast.dark(
        'Oops, upload failed. Please check your network and try again.'
      )
    }
  }

  const onUpload = async (item: any) => {
    const url = await upload(item.url)
    console.log(url)

    // eslint-disable-next-line consistent-return
    return new Promise((resolve, reject) => {
      const rate = Math.random()
      // @ts-ignore
      if (url) {
        return resolve({ fsid: rate.toString().slice(-6), remoteUrl: url })
      }
      // eslint-disable-next-line prefer-promise-reject-errors
      reject('Upload fail')
      // eslint-disable-next-line prefer-promise-reject-errors
      // eslint-disable-next-line consistent-return
      // setTimeout(() => {
      //   console.log(item)
      //   if (rate > 0.1) {
      //     // 成功
      //     return resolve({ fssid: rate.toString().slice(-6) })
      //   }
      //   // eslint-disable-next-line prefer-promise-reject-errors
      //   reject('Upload fail')
      // }, 1000)
    })
  }

  // 计算单词或者汉字字符数
  function computeCount(words: string) {
    let sLen = 0
    let str = words
    try {
      // 先将回车换行符做特殊处理
      // eslint-disable-next-line no-irregular-whitespace
      str = str.replace(/(\r\n+|\s+|　+)/g, '龘')
      // 处理英文字符数字，连续字母、数字、英文符号视为一个单词
      // eslint-disable-next-line no-control-regex
      str = str.replace(/[\x00-\xff]/g, 'm')
      // 合并字符m，连续字母、数字、英文符号视为一个单词
      str = str.replace(/m+/g, '*')
      // 去掉回车换行符
      str = str.replace(/龘+/g, '')
      // 返回字数
      sLen = str.length
    } catch (e) {
      console.log(e)
    }
    return sLen
  }

  function checkEmail(str: string): boolean {
    return /^([a-zA-Z0-9]+[_|_|\-|.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|_|.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,6}$/.test(
      str
    )
  }

  function checkValue(e: any) {
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const { name, value } = e.target
    switch (name) {
      case 'name':
      case 'body':
        setShowError(() => ({ ...showError, [name]: !value }))
        break
      case 'email':
        setShowError(() => ({
          ...showError,
          [name]: !checkEmail(value),
        }))
        break
      default:
        break
    }
  }

  function setFormValues(e: any, toNumber?: boolean) {
    e.preventDefault()
    console.log(+e.target.value)
    setForm({
      ...form,
      [e.target.name]: toNumber ? +e.target.value : e.target.value.trim(),
    })
    setShowError({
      ...showError,
      ...{
        [e.target.name]: false,
      },
    })
    // if (e.target.value) checkValue(e)
  }

  function clearForm() {
    setOpenMoreRating(false)
    setForm({
      ...initForm,
      ...{ name: getName() || '', email: getInputEmail() },
    })
    setValue([])
    setStep(0)
  }

  function nextChecked(): number {
    const { averageRating, costEffective, comfort, stretch, fitting, body } =
      form
    const showSomeError = (err: string) => {
      const allFun = {
        averageRating: averageRating < 1,
        costEffective: !costEffective,
        comfort: !comfort,
        stretch: stretch < 0,
        fitting: fitting < 0,
        body: !body,
      }
      setShowError({
        ...showError,
        ...{
          // @ts-ignore
          [err]: allFun[err],
        },
      })
    }
    if (!averageRating) {
      averageRatingRef?.current?.focus()
      toast.dark('Please rate overall score')
      showSomeError('averageRating')
      return 1
    }
    if (!costEffective) {
      costEffectiveRef?.current?.focus()
      toast.dark('Please rate the level of value for cost')
      showSomeError('costEffective')
      return 2
    }
    if (!comfort) {
      comfortRef?.current?.focus()
      toast.dark('Please rate level of comfort')
      showSomeError('comfort')
      return 3
    }
    if (stretch < 0) {
      stretchRef?.current?.focus()
      toast.dark('Please rate elasticity')
      showSomeError('stretch')
      return 4
    }
    if (fitting < 0) {
      fittingRef?.current?.focus()
      toast.dark('Please rate fit')
      showSomeError('fitting')
      return 5
    }
    if (!body) {
      bodyRef?.current?.focus()
      setShowError(() => ({ ...showError, body: !body }))
      toast.dark('Please write down your review')
      return 6
    }
    if (value.length && value.find((i) => !i.remoteUrl)) {
      toast.dark('Photos upload failed. Please try again')
      return 10
    }
    return 11
  }
  function submitChecked(): number {
    const { name, email } = form
    if (!name) {
      nameRef?.current?.focus()
      toast.dark('Please enter your name')
      return 7
    }
    window.localStorage.setItem('_nick_name', name)
    if (!email) {
      emailRef?.current?.focus()
      toast.dark('Please enter your email')
      return 8
    }
    window.localStorage.setItem('_review_email', email)
    if (!checkEmail(email)) {
      emailRef?.current?.focus()
      toast.dark('Please enter a valid email address')
      return 9
    }
    return 11
  }

  const handleClose = () => {
    clearForm()
    onClose()
  }

  const onConfirmClose = () => {
    confirm({
      title: (
        <div className="text-center font-semibold text-lg leading-1.2 px-2">
          Are you sure you want to quit?
        </div>
      ),
      description: (
        <div className="text-center font-medium text-gray-400 leading-tight">
          Your review content will not be saved.
        </div>
      ),
      dialogProps: {
        sx: {
          '.MuiPaper-root': {
            maxWidth: '320px',
            borderRadius: '0!important',
            px: '16px!important',
            py: '16px!important',
          },
          '.MuiDialogActions-root': {
            flexFlow: 'row-reverse wrap',
            pt: '4px!important',
          },
        },
      },
      cancellationText: 'Stay',
      cancellationButtonProps: {
        sx: {
          ...styleBtnBlack,
          ...{ mt: 0, width: '100%', order: 1 },
        },
      },
      confirmationText: 'Quit',
      confirmationButtonProps: {
        sx: {
          ...styleBtnWhite,
          ...{ mt: 2, ml: '0!important', width: '100%', order: 2 },
        },
      },
    })
      .then(() => {
        handleClose()
      })
      .catch(() => {})
  }
  const saveReviewFigure = (data: any) => {
    if (typeof window !== 'undefined') {
      window.localStorage.setItem(
        '_review_figure',
        JSON.stringify({
          height: data.height,
          weight: data.weight,
          bust: data.bust,
          waist: data.waist,
          hips: data.hips,
        })
      )
    }
  }
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  async function handleSubmitReviews() {
    try {
      const nextReviews = {
        overall_rating: form.averageRating,
        value_for_cost: form.costEffective,
        comfort_level: form.comfort,
        elasticity:
          STRETCH_ARR.find((item) => item.value === form.stretch)?.label ||
          'NULL',
        fit:
          FITTING_ARR.find((item) => item.value === form.fitting)?.label ||
          'NULL',
        review_words_number: form.body?.length || 0,
        photo_number: value.filter((i) => i.remoteUrl).length,
        name_content: form.name || 'NULL',
        email_content: form.email || 'NULL',
      }
      if (step === 0) {
        const nextResult = nextChecked()
        console.log('NextReviewButtonClick', {
          ...reviewReportData,
          ...nextReviews,
          review_next_result: nextResult,
        })
        window?.sensors?.track('NextReviewButtonClick', {
          ...reviewReportData,
          ...nextReviews,
          review_next_result: nextResult,
        })
        if (nextResult !== 11) {
          setLoading(false)
          return
        }
        // if (step === 0) {
        setStep(1)
        // return
        // }
        return
      }
      setLoading(true)
      const submitResult = submitChecked()
      const submitReviews = {
        height_content: figure.heights[form.height] || 'NULL',
        weight_content: figure.weights[form.weight] || 'NULL',
        bust_content: figure.busts[form.bust] || 'NULL',
        waist_content: figure.waists[form.waist] || 'NULL',
        hips_content: figure.hips[form.hips] || 'NULL',
        review_submit_result: submitResult,
        name_content: form.name || 'NULL',
        email_content: form.email || 'NULL',
      }
      window?.sensors?.track('SubmitReviewButtonClick', {
        ...reviewReportData,
        ...submitReviews,
        review_submit_result: submitResult,
      })
      console.log('SubmitReviewButtonClick', {
        ...reviewReportData,
        ...submitReviews,
        review_submit_result: submitResult,
      })
      if (submitResult !== 11) {
        setLoading(false)
        return
      }
      const token = await executeReCaptcha('submit')
      // @ts-ignore
      const postData = {
        recaptcha_token: token, // 从服务器得到的recaptcha token
        title: '', // 评论标题 *
        body: form.body, // 评论主体 *
        rating: form.averageRating, // 评分 *
        name: form.name, // name *
        email: form.email, // email *
        product_id: productId, // 商品spu id *
        product_handle: pHandle, // 商品handle  *
        product_title: pTitle, // 商品标题
        product_imgurl: pCover, // 商品图
        picture_urls: value
          .filter((i) => i.remoteUrl)
          .map((i) => i.remoteUrl)
          .join(','), // 评论图 多张图用,链接
        videos_urls: '', // 评论视频 多个用,链接
        extend: {
          cost_effective: form.costEffective,
          comfort: form.comfort,
          stretch: form.stretch,
          fitting: form.fitting,
        }, // json，表单内容 四个 *
        figure: {
          heights: form.height,
          weights: form.weight,
          busts: form.bust,
          waists: form.waist,
          hips: form.hips,
        },
        ytkey: '', // youtube的视频key
        uemail: loginEmail || getEmail(),
        // eslint-disable-next-line no-nested-ternary
        source: platform ? (platform === 'pc' ? 1 : 0) : upSm ? 1 : 0,
        isEmail,
      }
      submitTimer = setTimeout(() => {
        toast.dark('Submit timeout')
        setLoading(false)
      }, 30000)
      if (typeof navigator !== 'undefined' && !navigator.onLine) {
        toast.dark(
          'Network unavailable. Please check your network and try again.'
        )
        clearTimeout(submitTimer)
        setLoading(false)
        window?.sensors?.track('ReviewUploadFailed', {
          upload_failed_reason: 1,
        })
        console.log('ReviewUploadFailed', {
          upload_failed_reason: 1,
        })
      }
      const res = await fetch(`${BASE_URL}/review/submit`, {
        method: 'POST',
        mode: 'cors',
        headers: {
          'content-type': 'application/json',
        },
        body: JSON.stringify(postData),
      })
      console.log(res)
      if (res.status === 200 && res.ok) {
        // if (res.body)
        clearTimeout(submitTimer)
        const data = await res.json()
        if (data.status === 200) {
          saveReviewFigure(form)
          handleClose()
          clearForm()
          setLoading(false)
          scrollToReviews()
          toast.dark(
            'Upload Successful! Your comment will be displayed pending approval.'
          )
          // 评论后自动储存评论，两小时内回显
          // saveReview(data.body.result)
          window?.sensors?.track('ReviewUploadSuccess', {
            ...reviewReportData,
            // @ts-ignore
            // review_number: productReportData?.reviews?.total || 0,
            // average_overall_rating:
            //   +window?.productReportData.reviews.rating || 0,
            ...submitReviews,
            ...nextReviews,
          })
          console.log('ReviewUploadSuccess', {
            ...reviewReportData,
            // review_number: window?.productReportData.reviews.total || 0,
            // average_overall_rating:
            //   +window?.productReportData.reviews.rating || 0,
            ...submitReviews,
            ...nextReviews,
          })
          window?.sensors?.track('recaptcha_reviews_submit', {
            score: data.body.score,
          })
          console.log('recaptcha_reviews_submit', {
            score: data.body.score,
          })
        } else {
          toast.dark(
            `${
              data.message ||
              'Server error, please feed back through the customer service plug-in'
            }`
          )
          clearTimeout(submitTimer)
          setLoading(false)
        }
      } else if (res.status === 502) {
        toast.dark(`${res.statusText || 'Bad Gateway'}`)
        setLoading(false)
      }
    } catch (e: any) {
      window?.sensors?.track('ReviewUploadFailed', {
        upload_failed_reason: 3,
      })
      console.log(e)
      setLoading(false)
    }
  }
  function findFigure() {
    if (loginEmail) {
      getUserFigure(loginEmail)
    }
    const uemail = getEmail()
    if (uemail) {
      getUserFigure(uemail)
    } else {
      getUserFigureLocal()
    }
  }
  // 上报
  function marsWriteReviewBodySizesShow() {
    console.log('WriteReviewBodySizesShow', reviewReportData)
    window?.sensors?.track('WriteReviewBodySizesShow', {
      ...reviewReportData,
    })
  }
  useEffect(() => {
    if (step) {
      findFigure()
      marsWriteReviewBodySizesShow()
    }
  }, [step])
  // 控制google验证图标展示
  useEffect(() => {
    if (drawerOpen && step) {
      document
        .querySelector('.grecaptcha-badge')
        ?.classList.add('grecaptcha-badge__show')
    } else {
      document
        .querySelector('.grecaptcha-badge')
        ?.classList.remove('grecaptcha-badge__show')
    }
  }, [step, drawerOpen])
  /*
  useEffect(() => {
    if (drawerOpen) {
      if (loginEmail) {
        getUserFigure(loginEmail)
      }
      const uemail = getEmail()
      if (uemail) getUserFigure(uemail)
    }
  }, [drawerOpen])
  */

  useEffect(() => {
    setBodyWords(computeCount(form.body))
    return () => clearTimeout(submitTimer as any)
  }, [form.body])

  useEffect(() => {
    setNeedConfirm(!!form.body.length || !!value.length)
  }, [form.body.length, value.length])

  useEffect(() => {
    if (loginEmail) {
      setForm({
        ...form,
        email: loginEmail,
      })
    }
  }, [loginEmail])

  return (
    <Drawer
      open={drawerOpen}
      anchor={upSm ? 'right' : 'bottom'}
      onClose={
        // eslint-disable-next-line no-nested-ternary
        !loading ? (needConfirm ? onConfirmClose : handleClose) : () => null
      }
      sx={{
        '.MuiPaper-root.MuiDrawer-paper': {
          height: '100vh',
        },
      }}
    >
      <div className="block w-full py-7">
        <div className="flex justify-center items-center border-b-1 border-tag-grayef w-full h-14 fixed sm:w-96 top-0 z-10 px-3 bg-white text-black font-semibold select-none">
          {!loading && step === 1 ? (
            <div
              className="absolute left-3.5 top-1/2 transform -translate-y-1/2 cursor-pointer"
              onClick={() => setStep(0)}
            >
              <svg
                className="w-4.5 h-4.5"
                width="11"
                height="20"
                viewBox="0 0 11 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.54919 1.51562L1.06391 10.0009L9.54919 18.4862"
                  stroke="black"
                  strokeWidth="1.5"
                />
              </svg>
            </div>
          ) : null}
          Write A Review
          {!loading && step === 0 ? (
            <div
              className="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer"
              onClick={needConfirm ? onConfirmClose : handleClose}
            >
              <VscClose size={26} />
            </div>
          ) : null}
        </div>
      </div>
      {step === 0 && (
        <div
          className={`w-screen sm:w-96 px-4 pt-6 pb-3 ${
            loading ? 'text-opacity-90 pointer-events-none' : ''
          }`}
        >
          <div className="flex items-center">
            <div className="w-11 h-11">
              <div
                className="flex w-11 h-11 items-start justify-center overflow-hidden relative"
                style={{ paddingTop: `${(100 / 100) * 100}%` }}
              >
                <div className="absolute top-0 left-0 w-full h-full">
                  <Image
                    layout="fill"
                    objectFit="cover"
                    objectPosition="top"
                    src={pCover}
                  />
                </div>
              </div>
            </div>
            <div className="inline-block pl-3 min-w-0 overflow-hidden whitespace-nowrap overflow-ellipsis text-gray-400 font-semibold text-sm">
              {pTitle}
            </div>
          </div>
          <div className="flex justify-between items-center pt-3.5">
            <div
              ref={averageRatingRef}
              tabIndex={-1}
              className="font-semibold text-sm focus:text-tag-red-deep"
              onClick={() => setOpenMoreRating(true)}
            >
              Overall Rating
            </div>
            <Rating
              type="outline"
              value={form.averageRating}
              length={5}
              openHalf={false}
              onSelect={(e) => {
                setForm({ ...form, ...{ averageRating: e } })
                setOpenMoreRating(true)
              }}
            />
          </div>
          <Collapse in={openMoreRating}>
            <div className="flex justify-between items-center pt-2">
              <div
                className="text-gray-400 font-medium text-xs focus:text-tag-red-deep"
                ref={costEffectiveRef}
                tabIndex={-1}
              >
                Value For Cost
              </div>
              <Rating
                type="fill"
                value={form.costEffective}
                length={5}
                openHalf={false}
                onSelect={(e) => setForm({ ...form, ...{ costEffective: e } })}
              />
            </div>
            <div className="flex justify-between items-center pt-2">
              <div
                className="text-gray-400 font-medium text-xs focus:text-tag-red-deep"
                ref={comfortRef}
                tabIndex={-1}
              >
                Comfort Level
              </div>
              <Rating
                type="fill"
                value={form.comfort}
                length={5}
                openHalf={false}
                onSelect={(e) => setForm({ ...form, ...{ comfort: e } })}
              />
            </div>
            <div className="flex justify-between items-center pt-3">
              <div
                className="text-gray-400 font-medium text-xs focus:text-tag-red-deep"
                ref={stretchRef}
                tabIndex={-1}
              >
                Elasticity
              </div>
              <RadioButton
                value={form.stretch}
                className="-mx-1 flex flex-wrap justify-end"
                arr={STRETCH_ARR}
                onSelect={(index) =>
                  setForm({ ...form, ...{ stretch: STRETCH_ARR[index].value } })
                }
              />
            </div>
            <div className="flex justify-between items-center pt-3">
              <div
                className="text-gray-400 font-medium text-xs focus:text-tag-red-deep"
                ref={fittingRef}
                tabIndex={-1}
              >
                Fit
              </div>
              <RadioButton
                value={form.fitting}
                className="-mx-1 flex flex-wrap justify-end"
                arr={FITTING_ARR}
                onSelect={(index) =>
                  setForm({ ...form, ...{ fitting: FITTING_ARR[index].value } })
                }
              />
            </div>
          </Collapse>
          <div className="w-full relative mt-4 border-t border-t-1 border-tag-grayef pt-4">
            <textarea
              ref={bodyRef}
              name="body"
              placeholder=""
              className="w-full h-24 mb-3 outline-none text-sm resize-none leading-tight font-medium"
              maxLength={2000}
              defaultValue={form?.body}
              onChange={setFormValues}
              onBlur={
                form.body
                  ? checkValue
                  : () => setShowError(() => ({ ...showError, body: false }))
              }
            />

            <div className="absolute top-4 left-0 text-sm font-medium pointer-events-none">
              <div
                className={`flex text-gray-400${
                  !showError?.body && !form.body.length ? '' : ' hidden'
                }`}
              >
                <svg
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  fill="none"
                  className="mt-0.5 w-6 inline-block"
                >
                  <rect
                    x="2.66663"
                    y="12.3335"
                    width="10.6667"
                    height="1"
                    fill="#999999"
                  />
                  <path
                    d="M1.83337 12.8335V11.0406L10.8334 2.0406L12.6263 3.8335L3.62627 12.8335H1.83337Z"
                    stroke="#999999"
                  />
                </svg>
                <div className="pl-2">
                  You can write a review based on fit, style, comfort, quality,
                  and affordability.
                </div>
              </div>
              <div
                className={`text-tag-red-light ${
                  showError?.body ? '' : 'hidden'
                }`}
              >
                Please write down your review
              </div>
            </div>
            <div
              className={`text-xs text-gray-400 pb-0.5 ${
                bodyWords < 30 ? '' : ' hidden'
              }`}
              style={{
                transform: 'scale(0.8333)',
                transformOrigin: 'left top',
              }}
            >
              {/* *{bodyWords > 0 ? 'Left ' : 'Write '} */}
              {`*Write `}
              <span className="text-tag-orange-deep">{30 - bodyWords} </span>
              more words for a chance at a top review!
            </div>
          </div>
          <div className="w-full pb-16">
            <ImagePicker
              value={value}
              onChange={onChange}
              multiple
              max={8}
              mode="cover"
              // @ts-ignore
              onUpload={onUpload}
              quality={0.6}
              className="grid grid-cols-4 gap-x-2 gap-y-2 mx-0"
              outputWidth={1024}
              outputHeight={2048}
            >
              <svg
                className="w-full h-full cursor-pointer"
                width="80"
                height="80"
                viewBox="0 0 80 80"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="80" height="80" fill="#F5F5F5" />
                <text x="22" y="63" fontSize="12" fill="#666666">
                  Photo
                </text>
                <path
                  d="M28 42H49.3334H52V18H49.3334H28L28 20.6667V39.3333V42ZM34.6667 32.6667L37.8174 35.8173L42.6667 28.6667L49.3334 38H30.6667L34.6667 32.6667Z"
                  fill="#666666"
                />
              </svg>
            </ImagePicker>
          </div>
        </div>
      )}

      {step === 1 && (
        <div
          className={`w-screen sm:w-96 pb-20 ${
            loading ? 'text-opacity-90 pointer-events-none' : ''
          }`}
        >
          <div className="px-4 py-6">
            <div className="flex text-sm flex-wrap mb-1 font-medium flex-col">
              <div className="leading-1 space-x-2 text-black font-semibold">
                Your Measurements (Optional)
              </div>
              <div className="text-xs space-x-2 text-gray-400">
                Your input helps other shoppers
              </div>
            </div>
            <div className="relative inline-flex w-full mt-3.5 items-center justify-between text-xs">
              <span className="leading-1 space-x-2 text-sm font-medium">
                Height
              </span>
              <select
                name="height"
                onChange={(e) => setFormValues(e, true)}
                // defaultValue={form.height}
                value={form.height}
                className={`w-8/12 px-4 bg-transparent outline-none border bottom-1 border-tag-grayccc h-10 text-sm font-medium cursor-pointer ${
                  form.height === -1 && 'text-gray-400'
                }`}
              >
                <option value={-1}>Please Choose One</option>
                {figure?.heights?.map((i: any, idx: number) => (
                  <option value={idx} key={`height${idx}`}>
                    {i}
                  </option>
                ))}
              </select>
              <MdOutlineKeyboardArrowDown
                className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
                color="inherit"
                size={16}
              />
            </div>
            <div className="relative inline-flex w-full mt-4 items-center justify-between text-xs">
              <span className="leading-1 space-x-2 text-sm font-medium">
                Weight
              </span>
              <select
                name="weight"
                onChange={(e) => setFormValues(e, true)}
                // defaultValue={form.weight}
                value={form.weight}
                className={`w-8/12 px-4 bg-transparent outline-none border bottom-1 border-tag-grayccc h-10 text-sm font-medium cursor-pointer ${
                  form.weight === -1 && 'text-gray-400'
                }`}
              >
                <option value={-1}>Please Choose One</option>
                {figure?.weights?.map((i: any, idx: number) => (
                  <option value={idx} key={`weight${idx}`}>
                    {i}
                  </option>
                ))}
              </select>
              <MdOutlineKeyboardArrowDown
                className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
                color="inherit"
                size={16}
              />
            </div>
            <div className="relative inline-flex w-full mt-4 items-center justify-between text-xs">
              <span className="leading-1 space-x-2 text-sm font-medium">
                Bust
              </span>
              <select
                name="bust"
                onChange={(e) => setFormValues(e, true)}
                // defaultValue={form.bust}
                value={form.bust}
                className={`w-8/12 px-4 bg-transparent outline-none border bottom-1 border-tag-grayccc h-10 text-sm font-medium cursor-pointer ${
                  form.bust === -1 && 'text-gray-400'
                }`}
              >
                <option value={-1}>Please Choose One</option>
                {figure?.busts?.map((i: any, idx: number) => (
                  <option value={idx} key={`bust${idx}`}>
                    {i}
                  </option>
                ))}
              </select>
              <MdOutlineKeyboardArrowDown
                className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
                color="inherit"
                size={16}
              />
            </div>
            <div className="relative inline-flex w-full mt-4 items-center justify-between text-xs">
              <span className="leading-1 space-x-2 text-sm font-medium">
                Waist
              </span>
              <select
                name="waist"
                onChange={(e) => setFormValues(e, true)}
                // defaultValue={form.waist}
                value={form.waist}
                className={`w-8/12 px-4 bg-transparent outline-none border bottom-1 border-tag-grayccc h-10 text-sm font-medium cursor-pointer ${
                  form.waist === -1 && 'text-gray-400'
                }`}
              >
                <option value={-1}>Please Choose One</option>
                {figure?.waists?.map((i: any, idx: number) => (
                  <option value={idx} key={`waist${idx}`}>
                    {i}
                  </option>
                ))}
              </select>
              <MdOutlineKeyboardArrowDown
                className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
                color="inherit"
                size={16}
              />
            </div>
            <div className="relative inline-flex w-full mt-4 items-center justify-between text-xs">
              <span className="leading-1 space-x-2 text-sm font-medium">
                Hips
              </span>
              <select
                name="hips"
                onChange={(e) => setFormValues(e, true)}
                // defaultValue={form.hips}
                value={form.hips}
                placeholder="Please Choose One"
                className={`w-8/12 px-4 bg-transparent outline-none border bottom-1 border-tag-grayccc h-10 text-sm font-medium cursor-pointer ${
                  form.hips === -1 && 'text-gray-400'
                }`}
              >
                <option value={-1}>Please Choose One</option>
                {figure?.hips?.map((i: any, idx: number) => (
                  <option value={idx} key={`hips${idx}`}>
                    {i}
                  </option>
                ))}
              </select>
              <MdOutlineKeyboardArrowDown
                className="absolute right-3 top-1/2 transform -translate-y-1/2 cursor-pointer"
                color="inherit"
                size={16}
              />
            </div>
          </div>

          <div className="w-screen sm:w-96 pt-1.5 pb-1 bg-tag-grayf5" />

          <div className="px-4 pt-6">
            <div className="inline-flex text-sm flex-wrap mb-1 font-medium">
              <span className="leading-1 space-x-2">Name</span>
            </div>
            <div className="w-full relative">
              <input
                ref={nameRef}
                type="text"
                name="name"
                placeholder="Enter your name (public)"
                className="mt-1 border-tag-grayccc border-1 px-4 w-full outline-none text-sm text-black font-medium"
                maxLength={200}
                defaultValue={form?.name}
                onChange={setFormValues}
                onBlur={checkValue}
                style={{ height: '50px' }}
              />
              <div
                className={`pt-2 text-xs text-tag-red-deep ${
                  showError?.name ? '' : 'hidden'
                }`}
              >
                Please enter your name.
              </div>
            </div>
            <div className="inline-flex text-sm flex-wrap mt-4 mb-1 font-medium">
              <span className="leading-1 space-x-2">Email</span>
            </div>
            <div className="w-full relative">
              <input
                ref={emailRef}
                type="text"
                name="email"
                placeholder="Enter your email (private)"
                className="mt-1 border-tag-grayccc border-1 px-3.5 w-full outline-none text-sm text-black font-medium"
                maxLength={200}
                // defaultValue={form?.email}
                value={form?.email}
                onChange={setFormValues}
                onBlur={checkValue}
                style={{ height: '50px' }}
              />
              <div
                className={`pt-2 text-xs text-tag-red-deep ${
                  showError?.email ? '' : 'hidden'
                }`}
              >
                {`${
                  !form.email || form.email === ' '
                    ? 'Please enter your email.'
                    : 'Please enter a valid email address.'
                }`}
              </div>
            </div>

            <div className="text-xs text-gray-400 pt-2 pb-0.5 w-full hidden">
              This site is protected by reCAPTCHA and the Google
              <a
                href="https://policies.google.com/privacy"
                className="text-tag-orange-deep"
                target="_blank"
                rel="noreferrer"
              >
                {' '}
                Privacy Policy
              </a>{' '}
              and
              <a
                href="https://policies.google.com/terms"
                className="text-tag-orange-deep"
                target="_blank"
                rel="noreferrer"
              >
                {' '}
                Terms of Service
              </a>{' '}
              apply.
            </div>
          </div>
        </div>
      )}

      <div
        className={`flex justify-center items-center w-full fixed sm:w-96 bottom-0 z-50 px-3 bg-black text-white select-none ${
          loading
            ? 'text-white text-opacity-90 bg-gray-400 pointer-events-none cursor-not-allowed'
            : 'cursor-pointer'
        }`}
        style={{ height: '50px' }}
        onClick={() => handleSubmitReviews()}
      >
        {loading ? (
          <div className="relative">
            <div className="absolute -left-9 top-1/2 transform -translate-y-1/2 flex items-center">
              <span className="animate-spin inline-block">
                <AiOutlineLoading size={24} />
              </span>
            </div>
            Submit
          </div>
        ) : (
          (step === 0 && 'Next') || (step === 1 && 'Submit')
        )}
      </div>
    </Drawer>
  )
}
